import decoder from '../../../lib/decoder.js';
import ModelCartGroup from './cart_group.js'
import ModelCartItem from './cart_item.js'
import ModelTariff from './tariff.js'

const GROUP_TYPE = {
	vats: 'VATS',
	product: 'PRODUCT',
	mgp: 'MGP',
	numbers: 'NUMBERS',
	fmcNumbers: 'FMC_NUMBERS',
	mvnoNumbers: 'MVNO_NUMBERS',
	mvnoTariff: 'MVNO_TARIFF',
	portingNumbers: 'PORTING_NUMBERS',
	tariffs: 'TARIFFS',
	services: 'SERVICES',
	devices: 'DEVICES'
};

function ModelCart() {
	this.groups = [];
	this.items = {};
	this.cache = {
		selectedTariffsByProvider: null,
		selectedNumbersById: null,
		selectedNumbersCount: {}
	};
}

ModelCart.constants = {
	type: GROUP_TYPE
};

ModelCart.prototype.clearCache = function () {
	this.cache = {
		selectedTariffsByProvider: null,
		selectedNumbersById: null,
		selectedNumbersCount: {}
	};
};

ModelCart.prototype.getSelectedTariffsByProvider = function () {
	if (this.cache.selectedTariffsByProvider === null) {
		let tariffs = {};
		let items = this.items[GROUP_TYPE.tariffs].items;
		if (Array.isArray(items)) {
			items.forEach(item => {
				if (item.providerId > 0 && item.tariffId > 0) {
					let tariff = new ModelTariff();
					tariff.id = item.tariffId;
					tariff.name = item.name;
					tariffs[item.providerId] = tariff;
				}
			})
		}
		this.cache.selectedTariffsByProvider = tariffs;
	}
	return this.cache.selectedTariffsByProvider;
};

ModelCart.prototype.getSelectedNumbersById = function () {
	if (this.cache.selectedNumbersById === null) {
		let numbers = {};
		let types = [
			GROUP_TYPE.numbers,
			GROUP_TYPE.fmcNumbers,
			GROUP_TYPE.mvnoNumbers
		];
		types.forEach((type) => {
			let items = this.items[type].items;
			if (Array.isArray(items)) {
				items.forEach(item => {
					if (item.numberId > 0) {
						numbers[item.numberId] = true;
					}
				})
			}
		});
		this.cache.selectedNumbersById = numbers;
	}
	return this.cache.selectedNumbersById;
};

ModelCart.prototype.getSelectedNumbersCount = function (types) {
	if (!Array.isArray(types)) {
		types = [
			GROUP_TYPE.numbers,
			GROUP_TYPE.fmcNumbers,
			GROUP_TYPE.mvnoNumbers,
			GROUP_TYPE.portingNumbers
		];
	}
	let cacheId = 'types_' + types.join('_');
	if (!Object.hasOwnProperty.call(this.cache.selectedNumbersCount, cacheId)) {
		let count = 0;
		types.forEach((type) => {
			let items = this.items[type].items;
			if (Array.isArray(items)) {
				count += items.length
			}
		});
		this.cache.selectedNumbersCount[cacheId] = count;
	}
	return this.cache.selectedNumbersCount[cacheId];
};

ModelCart.prototype.getItems = function (type) {
	let items = this.items[type].items;
	if (Array.isArray(items)) {
		return items;
	}
	return [];
};

ModelCart.prototype.add = function (item) {
	let group = this.items[item.type];
	if (group) {
		group.items.unshift(item);
		group.isHidden = false;
		this.clearCache();
	}
};

ModelCart.prototype.remove = function (item) {
	let group = this.items[item.type];
	if (group) {
		let index;
		if (
			item.type === GROUP_TYPE.fmcNumbers
			|| item.type === GROUP_TYPE.mvnoNumbers
			|| item.type === GROUP_TYPE.numbers
		) {
			index = group.items.findIndex(cartItem => cartItem.numberId === item.numberId);
		} else {
			index = group.items.findIndex(cartItem => cartItem.id === item.id);
		}
		if (index > -1) {
			group.items.splice(index, 1);
			this.clearCache();
		}
	}
};

ModelCart.prototype.removeAll = function () {
	this.groups.forEach(group => {
		group.items.splice(0);
	});
	this.clearCache();
};

ModelCart.prototype.refresh = function (cart) {
	let items = {};

	cart.groups.forEach(group => {
		if (!group.items) {
			items[group.type] = [];
		} else {
			items[group.type] = group.items;
		}
	});

	this.groups.forEach(group => {
		if (group.items.length === items[group.type].length) {
			group.items.forEach((item, i) => {
				if (
					group.type === GROUP_TYPE.numbers
					|| group.type === GROUP_TYPE.fmcNumbers
					|| group.type === GROUP_TYPE.mvnoNumbers
				) {
					for (let key in items[group.type][i]) {
						if (key !== 'id') {
							item[key] = items[group.type][i][key];
						}
					}
				} else {
					group.items = items[group.type];
				}

			});
		} else {
			group['items'] = items[group.type];
			group['isHidden'] = items[group.type].length === 0;
		}
	});

	this.clearCache();
};

ModelCart.create = function (json) {
	if (!json) json = {};
	
	let model = new ModelCart();
	
	let types = [
		GROUP_TYPE.vats,
		GROUP_TYPE.product,
		GROUP_TYPE.mgp,
		GROUP_TYPE.numbers,
		GROUP_TYPE.fmcNumbers,
		GROUP_TYPE.mvnoNumbers,
		GROUP_TYPE.mvnoTariff,
		GROUP_TYPE.portingNumbers,
		GROUP_TYPE.tariffs,
		GROUP_TYPE.services,
		GROUP_TYPE.devices
	];
	
	types.forEach((type) => {
		let jsonGroup = json['GROUPS'][type];
		if (jsonGroup) {
			let group = decoder.decode(ModelCartGroup, jsonGroup);
			
			group.type = type;
			
			if (type === GROUP_TYPE.vats && json['SHOW_VATS'] === false) {
				group.isHidden = true;
			}
			
			if (type === GROUP_TYPE.portingNumbers) {
				group.canDelete = true;
			}
			
			let jsonItems = json[type];
			if (Array.isArray(jsonItems)) {
				group.items = decoder.decode(ModelCartItem, jsonItems, type);

			}
			
			model.groups.push(group);
			model.items[type] = group;
		}
	});
	
	return model;
};

export default ModelCart;